import React from "react";
import "../NagthaneComponent/NagthaneCss/LocationInfo.css";
import villageHall from "../Images/locationinfo.png"; 

export default function LocationInfo() {
  return (
    <div className="location-section">
      <div className="location-left">
        <h2 className="location-title">स्थान आणि भौगोलिक माहिती</h2>

        <p className="location-description">
          <span className="first-letter">ना</span>गठाणे हे महाराष्ट्र राज्यातील सातारा जिल्ह्यातील एक सुंदर आणि विकसित गाव आहे. हे गाव करेड तालुक्यात वसलेले असून, शांत वातावरण, मेहनती लोक आणि शेतीप्रधान जीवनशैली यासाठी ओळखले जाते.
          <br></br>
          गावाभोवती सुपीक जमीन, शेती आणि नैसर्गिक सौंदर्य आहे. नगठाणे हे प्रमुख 
          तालुका व जिला मुख्यालयाशी जोडलेले असल्यामुळे येथे पोहोचणे अतिशय 
          सोपे आहे. गावात मूलभूत सुविधा, शिक्षण संस्था, आरोग्य केंद्र आणि 
          ग्रामीणविकासाच्या योजना सक्रिय आहेत.
        </p>

      </div>

      <div className="location-right">
        <img src={villageHall} alt="Village Hall" className="location-image" />
      </div>
    </div>
  );
}
